import { useEffect } from "react";

interface SnackbarProps {
  open: boolean;
  message: string;
  onClose: () => void;
  duration?: number;
}

export function Snackbar({
  open,
  message,
  onClose,
  duration = 3000,
}: SnackbarProps) {
  useEffect(() => {
    if (!open) return;

    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [open, duration, onClose]);

  if (!open) return null;

  return (
    <div
      role="status"
      className="fixed top-4 left-1/2 z-50 -translate-x-1/2 rounded-md bg-panel-raised px-4 py-2.5 text-sm text-neutral-100 shadow-xl"
    >
      {message}
    </div>
  );
}
